import { Component, computed, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { UsuarioService } from 'src/app/services/usuario.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-delete-account',
    templateUrl: './delete-account.component.html',
    styleUrls: ['./delete-account.component.css'],
    standalone: false
})
export class DeleteAccountComponent {
  private _usuarioService = inject(UsuarioService);
  private router = inject(Router);
  private _location = inject(Location);
  private _authService = inject(AuthService);
  private _loadingService = inject(LoadingService);

  moreEliminarCuenta!: FormGroup;
  // estado
  error   = signal<string>('');
  loading = computed(() => this._loadingService.isLoading());
  validar: string = '';
  isFinished: boolean = false;

  constructor(private fb: FormBuilder){
    this.createForm();
  }

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    // Si necesitás (re)cargar usuario/cliente desde backend, hacelo bajo el loader:
    await this._loadingService.run(async () => {
      try {
        // Asegura bootstrap de sesión (idempotente, ok en web/nativo)
        await this._authService.ensureSession();
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        this.router.navigate(['/sign-in']);
      }
    });
  }

  createForm() {
    this.moreEliminarCuenta = this.fb.group({
      validar: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)] ],
    });
  }

  async deleteAccount(){
    // Evita doble submit si ya está cargando
    if (this.loading()) return;
    
    this.error.set('');

    const v = this.moreEliminarCuenta.getRawValue();

    if (!v.validar?.trim()) { this.error.set('Debe Completar el campo de verificación'); return; }
    if (v.validar?.trim() != 'ELIMINAR') { this.error.set('La verificación es incorrecta'); return; }

    // Respeta validaciones de template/reactivas
    if (this.moreEliminarCuenta.invalid) return;

    try {
      await this._loadingService.run(async () => {
        await firstValueFrom(this._usuarioService.deleteAccount(this._usuarioService.usuario().x_email!));

        this.isFinished = true;
      });
    } catch (e) {
      console.error(e);
      this.error.set('Error al eliminar el usuario');
    }
  }

  logout(){
    this._authService.logout();
  }

  back(){
    this._location.back();
  }
}
